export default __webpack_public_path__ + "static/media/worknest-small.9f3eb03c.svg";